/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `CREATED` - Created
 * * `NEW` - New
 * * `WORK_IN_PROGRESS` - Work In Progress
 * * `WAITING_APPROVAL` - Waiting Approval
 * * `COMPLETED` - Completed
 * * `ARCHIVED` - Archived
 * * `REJECTED` - Rejected
 * * `LINKED` - Linked
 * @export
 */
export const FromStatusEnum = {
    Created: 'CREATED',
    New: 'NEW',
    WorkInProgress: 'WORK_IN_PROGRESS',
    WaitingApproval: 'WAITING_APPROVAL',
    Completed: 'COMPLETED',
    Archived: 'ARCHIVED',
    Rejected: 'REJECTED',
    Linked: 'LINKED'
} as const;
export type FromStatusEnum = typeof FromStatusEnum[keyof typeof FromStatusEnum];


export function instanceOfFromStatusEnum(value: any): boolean {
    for (const key in FromStatusEnum) {
        if (Object.prototype.hasOwnProperty.call(FromStatusEnum, key)) {
            if (FromStatusEnum[key as keyof typeof FromStatusEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FromStatusEnumFromJSON(json: any): FromStatusEnum {
    return FromStatusEnumFromJSONTyped(json, false);
}

export function FromStatusEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): FromStatusEnum {
    return json as FromStatusEnum;
}

export function FromStatusEnumToJSON(value?: FromStatusEnum | null): any {
    return value as any;
}

export function FromStatusEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): FromStatusEnum {
    return value as FromStatusEnum;
}

